import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import Papa from 'papaparse';
import { toast } from 'react-toastify';

const baseStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '20px',
  borderWidth: 2,
  borderRadius: 2,
  borderColor: '#eeeeee',
  borderStyle: 'dashed',
  backgroundColor: '#fafafa',
  color: '#bdbdbd',
  transition: 'border .3s ease-in-out'
};

const activeStyle = {
  borderColor: '#2196f3'
};

const acceptStyle = {
  borderColor: '#00e676'
};

const rejectStyle = {
  borderColor: '#ff1744'
};

const requiredArray = ["number", "price", "categoryName"];

function DropzoneComponent(props) {
  const [files, setFiles] = useState([]);

  const onDrop = useCallback(async acceptedFiles => {

    const reader = new FileReader();
    let fileInfo = acceptedFiles[0];
    reader.readAsBinaryString(fileInfo);
    reader.onabort = () => console.log("file reading was aborted");
    reader.onerror = () => console.log("file reading failed");
    reader.onload = () => {
      Papa.parse(reader.result, {
        header: true,
        skipEmptyLines: true,
        complete: function(results) {
          console.log('[upload.js]::results::', typeof(results), results);

          // data fileds check
          if (!results || !results.meta || !Array.isArray(results.meta.fields) || results.meta.fields.length == 0 ){
            toast.error("headers in csv not found (number, category, format)")
            return;
          }

          let errorTxt = "";

          for (let index = 0; index < requiredArray.length; index++) {
            const element = requiredArray[index];
            
            if (results.meta.fields.indexOf(element) == -1){
              errorTxt = errorTxt + `${element} header required, `
            }
          }

          if (errorTxt){
            toast.error(errorTxt || "headers required")
            return;
          }

          // data limit check
          if ( results && results.data && results.data.length > 500 ){
            toast.error("csv file should not be more than 500 rows")
            return
          }
          setFiles({
            ...fileInfo,
            ...results,
          });
          props.uploadResults({
            ...fileInfo,
            ...results,
          })
        }
      });
    };

  }, []);

  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject
  } = useDropzone({
    onDrop,
    accept: 'text/csv'
  });

  const style = useMemo(() => ({
    ...baseStyle,
    ...(isDragActive ? activeStyle : {}),
    ...(isDragAccept ? acceptStyle : {}),
    ...(isDragReject ? rejectStyle : {})
  }), [
    isDragActive,
    isDragReject,
    isDragAccept
  ]);

  return (
    <section>
      <div {...getRootProps({style})}>
        <input {...getInputProps()} multiple={false}/>
        <div>Drag and drop your CSV here.</div>
      </div>
      <aside
        style={{
          marginBottom : "10px",
        }}
      >
        {files.path}
      </aside>
    </section>
  )
}

export default DropzoneComponent;